import React, { useState, useEffect, useRef } from 'react';
import {
  saveExpenseActual,
  saveExpenseForecast,
} from '../../utils/ActionCreator';
import { getAllExpenseCategory, getAllExpenseSubCategory,uploadcsvFiles } from '../../../../targetactioncreator';
import moment from 'moment';
import expense_sample from '../../../../../../../../images/expense_sample.csv'

const QuickAdd = ({ categories: categoriesProp = [],admin }) => {
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('forecast');

  // ── Category / subcategory state ──────────────────────────────────────────
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [savecategoryName, setSaveCategoryName] = useState('');

  // ── Expense form state ────────────────────────────────────────────────────
  const [expenseDate, setExpenseDate] = useState('');
  const [expenseAmount, setExpenseAmount] = useState('');
  const [expenseCategory, setExpenseCategory] = useState('');
  const [expenseSubcategory, setExpenseSubcategory] = useState('');
  const [expenseVendor, setExpenseVendor] = useState('');
  const [expensePaymentMode, setExpensePaymentMode] = useState('');
  const [expensePaymentStatus, setExpensePaymentStatus] = useState('');
  const [expenseGstApplicable, setExpenseGstApplicable] = useState('');
  const [expenseGstAmount, setExpenseGstAmount] = useState('');
  const [expenseInvoiceNo, setExpenseInvoiceNo] = useState('');
  const [expenseComment, setExpenseComment] = useState('');

  // ── Forecast form state ───────────────────────────────────────────────────
  const [forecastCategory, setForecastCategory] = useState('');
  const [forecastSubcategory, setForecastSubcategory] = useState('');
  const [forecastValue, setForecastValue] = useState('');
  const [forecastDate, setForecastDate] = useState(moment().format('YYYY-MM-DD'));
  const [forecastMonth, setForecastMonth] = useState(moment().format('MM'));
  const [forecastYear, setForecastYear] = useState(moment().format('YYYY'));

  // ── CSV upload state ──────────────────────────────────────────────────────
  const [csvFile, setCsvFile] = useState(null);
  const [csvFileName, setCsvFileName] = useState('');
  const [csvPreview, setCsvPreview] = useState([]);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [csvUploading, setCsvUploading] = useState(false);
  const [csvDragOver, setCsvDragOver] = useState(false);
  const fileInputRef = useRef(null);

  // ── Feedback ──────────────────────────────────────────────────────────────
  const [feedback, setFeedback] = useState({ msg: '', type: 'success', show: false });

  const toast = (msg, type = 'success') => {
    setFeedback({ msg, type, show: true });
    setTimeout(() => setFeedback(f => ({ ...f, show: false })), 3000);
  };

  // ── Load categories on mount ──────────────────────────────────────────────
  useEffect(() => {
    getAllExpenseCategory('notRequired', '', '', (callback) => {
      if (callback && callback?.status === 200) setCategoryOptions(callback.data);
      else setCategoryOptions([]);
    });
  }, []);

  const handleSubcategory = (categoryId) => {
    getAllExpenseSubCategory('notRequired', '', '', categoryId, (callback) => {
      if (callback && callback?.status === 200) setSubcategoryOptions(callback.data);
      else setSubcategoryOptions([]);
    });
  };

  const handleExpenseCategoryChange = (e) => {
    const val = e.target.value;
    setExpenseCategory(val);
    handleSubcategory(val);
    const match = categoryOptions.find(el => el?.categoryId == val);
    setSaveCategoryName(match?.categoryName ?? '');
  };

  const handleForecastCategoryChange = (e) => {
    const val = e.target.value;
    setForecastCategory(val);
    handleSubcategory(val);
    const match = categoryOptions.find(el => el?.categoryId == val);
    setSaveCategoryName(match?.categoryName ?? '');
  };

  // ── Reset helpers ─────────────────────────────────────────────────────────
  const resetExpenseForm = () => {
    setExpenseDate(''); setExpenseAmount(''); setExpenseCategory('');
    setExpenseSubcategory(''); setExpenseVendor(''); setExpensePaymentMode('');
    setExpensePaymentStatus(''); setExpenseGstApplicable(''); setExpenseGstAmount('');
    setExpenseInvoiceNo(''); setExpenseComment(''); setSaveCategoryName('');
    setSubcategoryOptions([]);
  };

  const resetForecastForm = () => {
    setForecastCategory(''); setForecastSubcategory(''); setForecastValue('');
    setForecastDate(moment().format('YYYY-MM-DD'));
    setForecastMonth(moment().format('MM'));
    setForecastYear(moment().format('YYYY'));
    setSaveCategoryName(''); setSubcategoryOptions([]);
  };

  const resetCsvForm = () => {
    setCsvFile(null); setCsvFileName(''); setCsvPreview([]); setCsvHeaders([]); setCsvUploading(false);
  };

  const handleClose = () => {
    setShowModal(false);
    resetExpenseForm(); resetForecastForm(); resetCsvForm();
  };

  // ── CSV helpers ───────────────────────────────────────────────────────────
  const parseCSVPreview = (text) => {
    const lines = text.split('\n').filter(l => l.trim());
    if (!lines.length) return;
    const headers = lines[0].split(',').map(h => h.trim().replace(/^"|"$/g, ''));
    setCsvHeaders(headers);
    const preview = lines.slice(1, 6).map(line => {
      const values = line.split(',').map(v => v.trim().replace(/^"|"$/g, ''));
      const row = {};
      headers.forEach((h, i) => { row[h] = values[i] ?? ''; });
      return row;
    });
    setCsvPreview(preview);
  };

  const handleFileSelect = (file) => {
    if (!file) return;
    if (!file.name.endsWith('.csv')) { toast('Please upload a valid .csv file', 'error'); return; }
    // if (file.size > 5 * 1024 * 1024) { toast('File size must be under 5MB', 'error'); return; }
    setCsvFile(file);
    setCsvFileName(file.name);
    const reader = new FileReader();
    reader.onload = (e) => parseCSVPreview(e.target.result);
    reader.readAsText(file);
  };

  const handleDrop = (e) => {
    e.preventDefault(); setCsvDragOver(false);
    handleFileSelect(e.dataTransfer.files[0]);
  };

  const handleCsvUpload = () => {
    if (!csvFile) { toast('Please select a CSV file first', 'error'); return; }
    setCsvUploading(true);
    console.log("uploadss")
    uploadcsvFiles(csvFile,callback=>{
      setCsvUploading(false);
      toast('CSV uploaded successfully!', 'success');
      resetCsvForm();
      window.dispatchEvent(new CustomEvent('refreshExpenseData'));

    })
    
    // setTimeout(() => {
    // }, 1500);
  };

  const downloadTemplate = () => {
   const a = document.createElement('a');
  a.href = expense_sample;
  a.download = 'expense_template.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  };

  // ── Submit: Add Expense ───────────────────────────────────────────────────
  const handleAddExpense = () => {
    if (!expenseDate || !expenseAmount || !expenseCategory) { toast('Please fill in Date, Amount and Category', 'error'); return; }
    const expensePayload = {
      expenseDate: expenseDate || moment().format('YYYY-MM-DD'),
      month: moment(expenseDate || new Date()).format('MMM YYYY'),
      expenseAmount: parseFloat(expenseAmount) || 0,
      expenseDescription: expenseComment || '',
      category: savecategoryName || 'UNCATEGORIZED',
      subCategory: expenseSubcategory || '',
      paidTo: expenseVendor || '',
      paymentMode: expensePaymentMode || '',
      paymentStatus: expensePaymentStatus || '',
      gstApplicable: expenseGstApplicable === 'yes' || expenseGstApplicable === true || expenseGstApplicable === 'true',
      gstAmount: parseFloat(expenseGstAmount) || 0,
      invoiceNumber: expenseInvoiceNo || '',
      createdAt: moment().format('YYYY-MM-DDTHH:mm:ss'),
    };
    saveExpenseActual(
      expensePayload,
      () => { toast('Expense added successfully!', 'success'); resetExpenseForm(); setShowModal(false); window.dispatchEvent(new CustomEvent('refreshExpenseData')); },
      (onErr) => toast(onErr?.response?.data?.message || onErr?.message || 'Failed to add expense.', 'error')
    );
  };

  // ── Submit: Add Forecast ──────────────────────────────────────────────────
  const handleForecast = () => {
    if (!forecastValue) { toast('Please enter a forecast value', 'error'); return; }
    const forecastPayload = {
      forecastDate: forecastDate,
      forecastAmount: parseFloat(forecastValue),
      category: savecategoryName ?? '',
      subCategory: forecastSubcategory ?? '',
    };
    saveExpenseForecast(
      forecastPayload,
      () => { toast('Forecast added successfully!', 'success'); resetForecastForm(); setShowModal(false); window.dispatchEvent(new CustomEvent('refreshExpenseData')); },
      (onErr) => toast(onErr?.response?.data?.message || onErr?.message || 'Failed to add forecast.', 'error')
    );
  };

  // ── Shared styles ─────────────────────────────────────────────────────────
  const inputStyle = {
    width: '100%', padding: '14px 18px', border: '2px solid #e2e8f0',
    borderRadius: '10px', fontSize: '14px', outline: 'none',
    transition: 'all 0.2s ease', boxSizing: 'border-box',
    backgroundColor: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  };
  const dateInputStyle = { ...inputStyle, fontFamily: 'system-ui, -apple-system, sans-serif', cursor: 'pointer', color: '#374151' };
  const labelStyle = { display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#374151' };
  const onFocus = (e) => { e.target.style.borderColor = '#015c57'; e.target.style.boxShadow = '0 0 0 3px rgba(1,92,87,0.1)'; };
  const onBlur  = (e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)'; };

  const TABS = [
    { key: 'forecast', label: 'Add Forecast' },
    { key: 'expense',  label: 'Add Expense'  },
    { key: 'csv',      label: 'Upload CSV'   },
  ];

  const EXPECTED_COLS = ['expenseDate', 'category', 'subCategory', 'amount', 'paidTo', 'paymentMode', 'paymentStatus', 'gstApplicable', 'gstAmount', 'invoiceNumber', 'comment'];

  return (
    <>
      {/* ── Trigger Button ── */}
      <button
        onClick={() => setShowModal(true)}
        style={{
          padding: '6px 12px', background: 'linear-gradient(145deg, rgb(0, 128, 122), rgb(0, 77, 73))', color: '#ffffff',
          border: 'none', borderRadius: '8px', fontSize: '12px', cursor: 'pointer',
          transition: 'all 0.2s ease', height: '32px', fontWeight: '600',
          width: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
          whiteSpace: 'nowrap',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = 'linear-gradient(145deg, rgb(0, 140, 134), rgb(0, 89, 85))'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'linear-gradient(145deg, rgb(0, 128, 122), rgb(0, 77, 73))'; }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/>
        </svg>
        <span>Quick Add</span>
      </button>

      {/* ── Modal ── */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1000, backdropFilter: 'blur(12px)' }}>
          <div style={{
            background: '#ffffff', width: '100%', height: '100vh',
            display: 'flex', flexDirection: 'column', overflow: 'hidden',
          }}>

            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #015c57 0%, #0a7d75 50%, #0e8d84 100%)',
              color: 'white', padding: '24px 32px',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              borderBottom: '1px solid rgba(255,255,255,0.15)',
              boxShadow: '0 4px 20px rgba(1,92,87,0.25)',
            }}>
              <div>
                <h2 style={{ margin: 0, fontSize: '24px', fontWeight: '700', letterSpacing: '-0.5px' }}>Quick Add</h2>
                <p style={{ margin: '6px 0 0', fontSize: '14px', opacity: 0.9 }}>Add expenses or forecasts quickly and efficiently</p>
              </div>
              <button onClick={handleClose} style={{
                background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '50%', width: '40px', height: '40px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'white', fontSize: '24px', cursor: 'pointer', transition: 'all 0.2s ease',
              }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.25)'; e.currentTarget.style.transform = 'scale(1.05)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; e.currentTarget.style.transform = 'scale(1)'; }}
              >×</button>
            </div>

            {/* Feedback toast */}
            {feedback.show && (
              <div style={{
                padding: '14px 32px', fontSize: '14px', fontWeight: '600',
                backgroundColor: feedback.type === 'success' ? '#ecfdf5' : '#fef2f2',
                color: feedback.type === 'success' ? '#065f46' : '#991b1b',
                borderBottom: `1px solid ${feedback.type === 'success' ? '#a7f3d0' : '#fecaca'}`,
                display: 'flex', alignItems: 'center', gap: '10px',
              }}>
                <span style={{
                  width: '20px', height: '20px', borderRadius: '50%',
                  backgroundColor: feedback.type === 'success' ? '#10b981' : '#ef4444',
                  color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '12px', fontWeight: 'bold', flexShrink: 0,
                }}>{feedback.type === 'success' ? '✓' : '✕'}</span>
                {feedback.msg}
              </div>
            )}

            {/* Tab bar */}
            <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', backgroundColor: '#f8fafc', justifyContent: 'flex-start', gap: '8px', padding: '0 32px' }}>
              {TABS.map(tab => (
                <button key={tab.key} onClick={() => setActiveTab(tab.key)} style={{
                  padding: '16px 20px', background: 'transparent',
                  color: activeTab === tab.key ? '#015c57' : '#64748b',
                  border: 'none',
                  borderBottom: activeTab === tab.key ? '3px solid #015c57' : '3px solid transparent',
                  fontSize: '15px', fontWeight: activeTab === tab.key ? '700' : '500',
                  cursor: 'pointer', transition: 'all 0.2s ease',
                }}
                  onMouseEnter={(e) => { if (activeTab !== tab.key) { e.currentTarget.style.backgroundColor = '#f1f5f9'; e.currentTarget.style.color = '#475569'; } }}
                  onMouseLeave={(e) => { if (activeTab !== tab.key) { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#64748b'; } }}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Scrollable content */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '32px', backgroundColor: '#ffffff', backgroundImage: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)' }}>

              {/* ══ EXPENSE FORM ══ */}
              {activeTab === 'expense' && (
                <div style={{ display: 'grid', gap: '24px' }}>
                  <FormHeader title="Add New Expense" subtitle="Fill in the details below to add a new expense record" />
                  <div style={{ display: 'grid', gap: '20px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div><label style={labelStyle}>Date *</label><input type="date" value={expenseDate} onChange={e => setExpenseDate(e.target.value)} style={dateInputStyle} onFocus={onFocus} onBlur={onBlur} /></div>
                      <div><label style={labelStyle}>Amount *</label><input type="number" placeholder="0.00" value={expenseAmount} onChange={e => setExpenseAmount(e.target.value)} style={inputStyle} onFocus={onFocus} onBlur={onBlur} /></div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div>
                        <label style={labelStyle}>Category *</label>
                        <select value={expenseCategory} onChange={handleExpenseCategoryChange} style={{ ...inputStyle, backgroundColor: 'white' }} onFocus={onFocus} onBlur={onBlur}>
                          <option value="">Select Category</option>
                          {categoryOptions.map(cat => <option key={cat.categoryId} value={cat.categoryId}>{cat.categoryName}</option>)}
                        </select>
                      </div>
                      <div>
                        <label style={labelStyle}>Sub-Category</label>
                        <select value={expenseSubcategory} onChange={e => setExpenseSubcategory(e.target.value)} style={{ ...inputStyle, backgroundColor: 'white' }} onFocus={onFocus} onBlur={onBlur} disabled={!subcategoryOptions.length}>
                          <option value="">Select Sub-Category</option>
                          {subcategoryOptions.map(sub => <option key={sub.subCategoryId || sub.subCategoryName} value={sub.subCategoryName}>{sub.subCategoryName}</option>)}
                        </select>
                      </div>
                    </div>
                    <div><label style={labelStyle}>Vendor / Description</label><input type="text" placeholder="Enter vendor or description" value={expenseVendor} onChange={e => setExpenseVendor(e.target.value)} style={inputStyle} onFocus={onFocus} onBlur={onBlur} /></div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div>
                        <label style={labelStyle}>Payment Mode</label>
                        <select value={expensePaymentMode} onChange={e => setExpensePaymentMode(e.target.value)} style={{ ...inputStyle, backgroundColor: 'white' }} onFocus={onFocus} onBlur={onBlur}>
                          <option value="">Select</option>
                          <option value="Cash">Cash</option><option value="Card">Card</option>
                          <option value="UPI">UPI</option><option value="Bank Transfer">Bank Transfer</option>
                          <option value="Cheque">Cheque</option>
                        </select>
                      </div>
                      <div>
                        <label style={labelStyle}>Payment Status</label>
                        <select value={expensePaymentStatus} onChange={e => setExpensePaymentStatus(e.target.value)} style={{ ...inputStyle, backgroundColor: 'white' }} onFocus={onFocus} onBlur={onBlur}>
                          <option value="">Select</option>
                          <option value="Paid">Paid</option><option value="Pending">Pending</option><option value="Partial">Partial</option>
                        </select>
                      </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div>
                        <label style={labelStyle}>GST Applicable</label>
                        <select value={expenseGstApplicable} onChange={e => setExpenseGstApplicable(e.target.value)} style={{ ...inputStyle, backgroundColor: 'white' }} onFocus={onFocus} onBlur={onBlur}>
                          <option value="">Select</option><option value="yes">Yes</option><option value="no">No</option>
                        </select>
                      </div>
                      <div><label style={labelStyle}>GST Amount</label><input type="number" placeholder="0.00" value={expenseGstAmount} onChange={e => setExpenseGstAmount(e.target.value)} style={inputStyle} onFocus={onFocus} onBlur={onBlur} disabled={expenseGstApplicable !== 'yes'} /></div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div><label style={labelStyle}>Invoice No.</label><input type="text" placeholder="Enter invoice number" value={expenseInvoiceNo} onChange={e => setExpenseInvoiceNo(e.target.value)} style={inputStyle} onFocus={onFocus} onBlur={onBlur} /></div>
                      <div><label style={labelStyle}>Comment</label><input type="text" placeholder="Optional comment" value={expenseComment} onChange={e => setExpenseComment(e.target.value)} style={inputStyle} onFocus={onFocus} onBlur={onBlur} /></div>
                    </div>
                    <FormActions onCancel={handleClose} onSubmit={handleAddExpense} submitLabel="Add Expense" />
                  </div>
                </div>
              )}

              {/* ══ FORECAST FORM ══ */}
              {activeTab === 'forecast' && (
                <div style={{ display: 'grid', gap: '24px' }}>
                  <FormHeader title="Add New Forecast" subtitle="Create a budget forecast for future expense planning" />
                  <div style={{ display: 'grid', gap: '20px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                      <div>
                        <label style={labelStyle}>Category *</label>
                        <select value={forecastCategory} onChange={handleForecastCategoryChange} style={{ ...inputStyle, backgroundColor: 'white' }} onFocus={onFocus} onBlur={onBlur}>
                          <option value="">Select Category</option>
                          {categoryOptions.map(cat => <option key={cat.categoryId} value={cat.categoryId}>{cat.categoryName}</option>)}
                        </select>
                      </div>
                      <div>
                        <label style={labelStyle}>Sub-Category</label>
                        <select value={forecastSubcategory} onChange={e => setForecastSubcategory(e.target.value)} style={{ ...inputStyle, backgroundColor: 'white' }} onFocus={onFocus} onBlur={onBlur} disabled={!subcategoryOptions.length}>
                          <option value="">Select Sub-Category</option>
                          {subcategoryOptions.map(sub => <option key={sub.subCategoryId || sub.subCategoryName} value={sub.subCategoryName}>{sub.subCategoryName}</option>)}
                        </select>
                      </div>
                    </div>
                    <div><label style={labelStyle}>Forecast Amount *</label><input type="number" placeholder="0.00" value={forecastValue} onChange={e => setForecastValue(e.target.value)} style={inputStyle} onFocus={onFocus} onBlur={onBlur} /></div>
                    <div><label style={labelStyle}>Forecast Date *</label><input type="date" value={forecastDate} onChange={e => setForecastDate(e.target.value)} style={dateInputStyle} onFocus={onFocus} onBlur={onBlur} /></div>
                    <FormActions onCancel={handleClose} onSubmit={handleForecast} submitLabel="Add Forecast" />
                  </div>
                </div>
              )}

              {/* ══ CSV UPLOAD FORM ══ */}
              {activeTab === 'csv' && (
                <div style={{ display: 'grid', gap: '24px',  margin: '0 auto', width: '100%' }}>
                  <FormHeader title="Upload CSV" subtitle="Bulk import expenses using a CSV file. Download the template below to get started." />

                  {/* Template Download Section */}
                  <div style={{
                    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                    border: '1px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{
                        width: '48px', height: '48px',
                        background: 'linear-gradient(135deg, #015c57, #0a7d75)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                          <polyline points="14,2 14,8 20,8"/>
                          <line x1="12" y1="18" x2="12" y2="12"/>
                          <line x1="9" y1="15" x2="15" y2="15"/>
                        </svg>
                      </div>
                      <div>
                        <div style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b', marginBottom: '4px' }}>
                          Download CSV Template
                        </div>
                        <div style={{ fontSize: '13px', color: '#64748b', lineHeight: '1.4' }}>
                          Get the pre-formatted template with all required columns for bulk expense import
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={downloadTemplate}
                      style={{
                        padding: '10px 20px',
                        background: 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)',
                        color: '#ffffff',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                        boxShadow: '0 2px 8px rgba(1,92,87,0.25)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontFamily: 'system-ui, -apple-system, sans-serif',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #0a7d75 0%, #0e8d84 100%)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(1,92,87,0.35)';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(1,92,87,0.25)';
                        e.currentTarget.style.transform = 'translateY(0)';
                      }}
                    >
                      <svg style={{width:'auto'}} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7 10 12 15 17 10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                      Download Template
                    </button>
                  </div>



                  {/* Drop zone */}
                  <div
                    onDragOver={(e) => { e.preventDefault(); setCsvDragOver(true); }}
                    onDragLeave={() => setCsvDragOver(false)}
                    onDrop={handleDrop}
                    onClick={() => fileInputRef.current?.click()}
                    style={{
                      border: `2px dashed ${csvDragOver ? '#015c57' : csvFile ? '#22c55e' : '#cbd5e1'}`,
                      borderRadius: '16px', padding: '48px 24px', textAlign: 'center', cursor: 'pointer',
                      transition: 'all 0.25s ease',
                      backgroundColor: csvDragOver ? 'rgba(1,92,87,0.04)' : csvFile ? 'rgba(34,197,94,0.04)' : '#fafafa',
                    }}
                  >
                    <input ref={fileInputRef} type="file" accept=".csv" style={{ display: 'none' }} onChange={(e) => handleFileSelect(e.target.files[0])} />

                    {csvFile ? (
                      <>
                        <div style={{ width: '56px', height: '56px', borderRadius: '14px', background: 'linear-gradient(135deg, #22c55e, #16a34a)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        </div>
                        <div style={{ fontSize: '16px', fontWeight: '700', color: '#15803d', marginBottom: '6px' }}>{csvFileName}</div>
                        <div style={{ fontSize: '13px', color: '#6b7280' }}>File selected — click to change</div>
                        <button onClick={(e) => { e.stopPropagation(); resetCsvForm(); }} style={{
                          marginTop: '14px', padding: '6px 14px', background: '#fee2e2',
                          color: '#dc2626', border: '1px solid #fca5a5', borderRadius: '8px',
                          fontSize: '12px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease',
                        }}
                          onMouseEnter={(e) => { e.currentTarget.style.background = '#fca5a5'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.background = '#fee2e2'; }}
                        >Remove</button>
                      </>
                    ) : (
                      <>
                        <div style={{ width: '56px', height: '56px', borderRadius: '14px', background: 'linear-gradient(135deg, #015c57, #0a7d75)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                            <polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                          </svg>
                        </div>
                        <div style={{ fontSize: '16px', fontWeight: '700', color: '#1e293b', marginBottom: '8px' }}>
                          {csvDragOver ? 'Drop your file here' : 'Drag & drop your CSV file'}
                        </div>
                        <div style={{ fontSize: '13px', color: '#6b7280' }}>or <span style={{ color: '#015c57', fontWeight: '600', textDecoration: 'underline' }}>browse to upload</span></div>
                        <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '10px' }}>Supports .csv files up to 5MB</div>
                      </>
                    )}
                  </div>

                  {/* Preview table */}
                  {csvPreview.length > 0 && (
                    <div>
                      <div style={{ fontSize: '14px', fontWeight: '600', color: '#374151', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#015c57" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                        </svg>
                        Preview (first {csvPreview.length} rows)
                      </div>
                      <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px', minWidth: '600px' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#f1f5f9' }}>
                              {csvHeaders.map(h => (
                                <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: '700', color: '#475569', whiteSpace: 'nowrap', borderBottom: '1px solid #e2e8f0', letterSpacing: '0.04em', fontSize: '11px', textTransform: 'uppercase' }}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {csvPreview.map((row, i) => (
                              <tr key={i} style={{ backgroundColor: i % 2 === 0 ? 'white' : '#f8fafc' }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f9ff'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = i % 2 === 0 ? 'white' : '#f8fafc'}
                              >
                                {csvHeaders.map(h => (
                                  <td key={h} style={{ padding: '10px 14px', color: '#374151', borderBottom: '1px solid #f1f5f9', whiteSpace: 'nowrap', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {row[h] || <span style={{ color: '#9ca3af' }}>—</span>}
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* Actions */}
                  <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '8px' }}>
                    <button onClick={handleClose} style={cancelBtnStyle}
                      onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.color = '#475569'; e.currentTarget.style.backgroundColor = '#f8fafc'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.color = '#64748b'; e.currentTarget.style.backgroundColor = 'transparent'; }}
                    >Cancel</button>
                    <button onClick={handleCsvUpload} disabled={!csvFile || csvUploading} style={{
                      ...submitBtnStyle,
                      opacity: !csvFile || csvUploading ? 0.6 : 1,
                      cursor: !csvFile || csvUploading ? 'not-allowed' : 'pointer',
                      display: 'flex', alignItems: 'center', gap: '8px',
                    }}
                      onMouseEnter={(e) => { if (csvFile && !csvUploading) { e.currentTarget.style.background = 'linear-gradient(135deg, #0a7d75 0%, #0e8d84 100%)'; e.currentTarget.style.transform = 'translateY(-1px)'; } }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                    >
                      {csvUploading ? (
                        <>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 1s linear infinite' }}>
                            <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
                          </svg>
                          Uploading…
                        </>
                      ) : 'Upload CSV'}
                    </button>
                  </div>

                  <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
                </div>
              )}

            </div>
          </div>
        </div>
      )}
    </>
  );
};

// ── Small reusable sub-components ─────────────────────────────────────────────
const FormHeader = ({ title, subtitle }) => (
  <div style={{
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
    padding: '20px 24px', borderRadius: '12px',
    border: '1px solid #e2e8f0', borderLeft: '4px solid #015c57',
  }}>
    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1e293b', marginBottom: '6px' }}>{title}</h3>
    <p style={{ margin: 0, fontSize: '14px', color: '#64748b', lineHeight: '1.5' }}>{subtitle}</p>
  </div>
);

const FormActions = ({ onCancel, onSubmit, submitLabel }) => (
  <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end', marginTop: '12px' }}>
    <button onClick={onCancel} style={cancelBtnStyle}
      onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.color = '#475569'; e.currentTarget.style.backgroundColor = '#f8fafc'; }}
      onMouseLeave={(e) => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.color = '#64748b'; e.currentTarget.style.backgroundColor = 'transparent'; }}
    >Cancel</button>
    <button onClick={onSubmit} style={submitBtnStyle}
      onMouseEnter={(e) => { e.currentTarget.style.background = 'linear-gradient(135deg, #0a7d75 0%, #0e8d84 100%)'; e.currentTarget.style.boxShadow = '0 6px 16px rgba(1,92,87,0.4)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(1,92,87,0.3)'; e.currentTarget.style.transform = 'translateY(0)'; }}
    >{submitLabel}</button>
  </div>
);

const cancelBtnStyle = {
  padding: '12px 28px', background: 'transparent', color: '#64748b',
  border: '2px solid #e2e8f0', borderRadius: '10px', fontSize: '14px',
  fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s ease',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
};

const submitBtnStyle = {
  padding: '12px 32px', background: 'linear-gradient(135deg, #015c57 0%, #0a7d75 100%)', color: 'white',
  border: 'none', borderRadius: '10px', fontSize: '14px',
  fontWeight: '600', cursor: 'pointer', minWidth: '140px',
  transition: 'all 0.2s ease', boxShadow: '0 4px 12px rgba(1,92,87,0.3)',
};

export default QuickAdd;